module.exports = __webpack_public_path__ + "components/page-footer/static/surf-forecast__logo--white-62a77c010c8220fc0c52b7ab92a9dce4.png";